<template>
<div class="chapter">
<div class="inner_page">
<section aria-labelledby="headerloi01" class="chapter" epub:type="frontmatter" id="loi">
<header id="headerloi01">
<h1 class="ctfm"><span aria-label="vi" class="page" id="pvi" role="doc-pagebreak"></span><span aria-label="vii" class="page" id="pvii" role="doc-pagebreak"></span><a class="xref" href="#/chilvovsky0005#toc">Illustrations</a></h1>
</header>
<p class="toc1"><a class="xref" href="#/chilvovsky0007#fig000i">Figure 0.1.   </a>A plainclothes decoy with the Los Angeles Police Department waiting on a street corner in 1964.</p>
<p class="toc1"><a class="xref" href="#/chilvovsky0008#fig0101">Figure 1.1.   </a>A peek inside a Greenwich Village gay bar in <i>Call Her Savage</i>.</p>
<p class="toc1"><a class="xref" href="#/chilvovsky0008#fig0102">Figure 1.2.   </a>“Helen Morgan Jr. and Jean Malin at the Smart Club Abbey,” in <i>Vanity Fair</i>.</p>
<p class="toc1"><a class="xref" href="#/chilvovsky0010#fig0301">Figure 3.1.   </a>Officer Max K. Hurlbut outside Ferndell No. 9 in Griffith Park, Los Angeles.</p>
<p class="toc1"><a class="xref" href="#/chilvovsky0011#fig0401">Figure 4.1.   </a>“A policeman in tight-pants disguise,” per <i>Life</i> magazine in 1964.</p>
<p class="toc1"><a class="xref" href="#/chilvovsky0011#fig0402">Figure 4.2.   </a>A Los Angeles Police Department decoy speaks with a suspect in Hollywood.</p>
<p class="toc1"><a class="xref" href="#/chilvovsky0011#fig0403">Figure 4.3.   </a>“Playing ‘footsie’ in a ‘tearoom,’” in Denny Pace’s <i>Handbook of Vice Control</i>.</p>
<p class="toc1"><a class="xref" href="#/chilvovsky0011#fig0404">Figure 4.4.   </a>“A toilet snipe looking for a date,” in Denny Pace’s <i>Handbook of Vice Control</i>.</p>
<p class="toc1"><a class="xref" href="#/chilvovsky0012#fig0501">Figure 5.1.   </a>The interior of the men’s room in Mansfield’s Central Park, as printed in the <i>FBI Enforcement Bulletin</i>.</p>
<p class="toc1"><a class="xref" href="#/chilvovsky0012#fig0502">Figure 5.2.   </a>A diagram of the Central Park men’s room, drawn by Lieutenant Bill Spognardi of the Mansfield Police Department.</p>
<p class="toc1"><a class="xref" href="#/chilvovsky0012#fig0503">Figure 5.3.   </a>Lieutenant Bill Spognardi manning a hidden camera in the Central Park men’s room, as printed in the <i>FBI Enforcement Bulletin</i>.</p>
<p class="toc1"><a class="xref" href="#/chilvovsky0013#fig0601">Figure 6.1.   </a>The “frantic hour” on Los Angeles’s Main Street, in <i>Life</i>.</p>
<p class="toc1"><a class="xref" href="#/chilvovsky0013#fig0602">Figure 6.2.   </a>“A homosexual sits on a rail in Los Angeles’s Pershing Square,” in <i>Life</i>.</p>
<p class="toc1"><a class="xref" href="#/chilvovsky0013#fig0603">Figure 6.3.   </a>Urban gay street life in New York City, in <i>Life</i>.</p>
<p class="toc1"><a class="xref" href="#/chilvovsky0013#fig0604">Figure 6.4.   </a>A decoy and his partner arrest a suspect in Hollywood, in <i>Life</i>.</p>
<p class="toc1"><a class="xref" href="#/chilvovsky0013#fig0605">Figure 6.5.   </a>The cover of the “Purple Pamphlet.”</p>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// chi-lvovsky-0006.vue?b6b7ed92